import { IOnlinePharmacyConfig } from "./online-pharmacy-config.interface";
import { VETCOVE_URL, ONLINE_PHARMACY_URL } from "../../config/params";

export const mapOnlinePharmacyConfig = (data?: IOnlinePharmacyConfig): IOnlinePharmacyConfig => {
  if (!data) {
    return {
      isServiceEnabled: false,
      shopUrl: VETCOVE_URL,
      comingSoon: {
        title: "Coming Soon",
        message: "Our GoodVets Online pharmacy is coming soon. Stay tuned for updates!",
        imageUrlWeb: "/assets/images/coming-soon.svg",
        learnMoreUrl: ONLINE_PHARMACY_URL,
      },
      banner: {
        title: "Your Vet's Pharmacy, Online.",
        description: "Order and manage your pet's medications online, directly through your GoodVets care team.",
        buttonText: "Shop Now",
        imageUrlWeb: "/assets/images/hero-banner.png",
        actionUrl: VETCOVE_URL,
      },
    };
  }

  return {
    isServiceEnabled: data.isServiceEnabled,
    shopUrl: data.shopUrl,
    comingSoon: {
      title: data.comingSoon.title || "Coming Soon",
      message: data.comingSoon.message || "Our GoodVets Online pharmacy is coming soon. Stay tuned for updates!",
      imageUrlWeb: data.comingSoon.imageUrlWeb || "/assets/images/coming-soon.svg",
      learnMoreUrl: data.comingSoon.learnMoreUrl || ONLINE_PHARMACY_URL,
    },
    banner: {
      title: data.banner.title || "Your Vet's Pharmacy, Online.",
      description:
        data.banner.description ||
        "Order and manage your pet's medications online, directly through your GoodVets care team.",
      buttonText: data.banner.buttonText || "Shop Now",
      imageUrlWeb: data.banner.imageUrlWeb,
      actionUrl: data.banner.actionUrl || VETCOVE_URL,
    },
  };
};
